<template>
  <div class="order-create__row custom-row">
    <div class="order-create__col custom-col custom-col--100">
<!--      <div class="order-create__section-label section-label"-->
<!--           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">-->
<!--        <div class="admin-edit" @click="editTranslate(['fba_addProductToWarehouse'])"></div>-->
<!--        {{ $t('fbm_EngravingFile.localization_value.value') }}-->
<!--      </div>-->

      <div class="mb-3 section-label"
           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
                  'fbm_EngravingFileName',
                  'calculatorEngraving_EmbroideryCalculator',
                  'calculatorEngraving_TShirtPrinting',
                  'calculatorEngraving_LeatherStamp',
                  'calculatorEngraving_PhotoPrint',
                ])"></div>


<!--        <div class="order-create__row custom-row">-->
<!--          <div class="order-create__col custom-col custom-col&#45;&#45;16">-->
<!--            <DefaultCheckbox-->
<!--                class="mr-3 mb-2"-->
<!--                v-model="FBM.data.isEngraving"-->
<!--                :label="$t('fbm_EngravingFileName.localization_value.value')"-->
<!--                @changeCheckbox="(val) => changeCustomizationType('isEngraving', val)"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="order-create__col custom-col"-->
<!--               v-if="FBM.data.isEngraving">-->
<!--            <Engraving-->
<!--                :FBM="FBM"-->
<!--                :engravingCustomOptions="engravingCustomOptions"-->
<!--                @changeCustomization="changeCustomization"-->
<!--                @changeQuantity="changeQuantity"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="order-create__col custom-col custom-col&#45;&#45;16"-->
<!--               v-if="!isWarehouseLodz">-->
<!--            <DefaultCheckbox-->
<!--                class="mr-3"-->
<!--                v-model="FBM.data.Embroidery.data.isEmbroidery"-->
<!--                :label="$t('calculatorEngraving_EmbroideryCalculator.localization_value.value')"-->
<!--                @changeCheckbox="(val) => changeCustomizationType('isEmbroidery', val)"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="order-create__col custom-col"-->
<!--               v-if="FBM.data.Embroidery.data.isEmbroidery">-->
<!--            <Embroidery-->
<!--                :embroideryCustomOptions="embroideryCustomOptions"-->
<!--                :FBM="FBM"-->
<!--                @changeCustomization="changeCustomization"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="order-create__col custom-col custom-col&#45;&#45;16"-->
<!--               v-if="!isWarehouseLodz">-->
<!--            <DefaultCheckbox-->
<!--                class="mr-3"-->
<!--                v-model="FBM.data.TShirtPrinting.data.isTShirtPrinting"-->
<!--                :label="$t('calculatorEngraving_TShirtPrinting.localization_value.value')"-->
<!--                @changeCheckbox="(val) => changeCustomizationType('isTShirtPrinting', val)"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="order-create__col custom-col"-->
<!--               v-if="FBM.data.TShirtPrinting.data.isTShirtPrinting">-->
<!--            <TShirtPrinting-->
<!--                :FBM="FBM"-->
<!--                :dtgPrintingCustomOptions="dtgPrintingCustomOptions"-->
<!--                @changeCustomization="changeCustomization"-->
<!--                @changeQuantity="changeQuantity"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="order-create__col custom-col custom-col&#45;&#45;16"-->
<!--               v-if="!isWarehouseLodz">-->
<!--            <DefaultCheckbox-->
<!--                class="mr-3 mb-2"-->
<!--                v-model="FBM.data.LeatherStamp.data.isLeatherStamp"-->
<!--                :label="$t('calculatorEngraving_LeatherStamp.localization_value.value')"-->
<!--                @changeCheckbox="(val) => changeCustomizationType('isLeatherStamp', val)"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="order-create__col custom-col"-->
<!--               v-if="FBM.data.LeatherStamp.data.isLeatherStamp">-->
<!--            <LeatherStamp-->
<!--                :FBM="FBM"-->
<!--                :leatherStampCustomOptions="leatherStampCustomOptions"-->
<!--                @changeCustomization="changeCustomization"-->
<!--                @changeQuantity="changeQuantity"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="order-create__col custom-col custom-col&#45;&#45;16"-->
<!--               v-if="!isWarehouseLodz">-->
<!--            <DefaultCheckbox-->
<!--                v-model="FBM.data.PhotoPrint.data.isPhotoPrint"-->
<!--                :label="$t('calculatorEngraving_PhotoPrint.localization_value.value')"-->
<!--                @changeCheckbox="(val) => changeCustomizationType('isPhotoPrint', val)"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="order-create__col custom-col"-->
<!--               v-if="FBM.data.PhotoPrint.data.isPhotoPrint">-->
<!--            <PhotoPrint-->
<!--                :FBM="FBM"-->
<!--                :photoPrintSizeOptions="photoPrintSizeOptions"-->
<!--                :photoPrintCustomOptions="photoPrintCustomOptions"-->
<!--                @changeCustomization="changeCustomization"-->
<!--                @changeQuantity="changeQuantity"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->


        <div class="d-flex flex-wrap">
          <DefaultCheckbox
              class="mr-3 mb-2"
              v-model="FBM.data.isEngraving"
              :label="$t('fbm_EngravingFileName.localization_value.value')"
              @changeCheckbox="(val) => changeCustomizationType('isEngraving', val)"
          />
          <DefaultCheckbox
              v-if="!isWarehouseLodz"
              class="mr-3"
              v-model="FBM.data.Embroidery.data.isEmbroidery"
              :label="$t('calculatorEngraving_EmbroideryCalculator.localization_value.value')"
              @changeCheckbox="(val) => changeCustomizationType('isEmbroidery', val)"
          />
          <DefaultCheckbox
              v-if="!isWarehouseLodz"
              class="mr-3"
              v-model="FBM.data.TShirtPrinting.data.isTShirtPrinting"
              :label="$t('calculatorEngraving_TShirtPrinting.localization_value.value')"
              @changeCheckbox="(val) => changeCustomizationType('isTShirtPrinting', val)"
          />
          <DefaultCheckbox
              v-if="!isWarehouseLodz"
              class="mr-3 mb-2"
              v-model="FBM.data.LeatherStamp.data.isLeatherStamp"
              :label="$t('calculatorEngraving_LeatherStamp.localization_value.value')"
              @changeCheckbox="(val) => changeCustomizationType('isLeatherStamp', val)"
          />
          <DefaultCheckbox
              v-if="!isWarehouseLodz"
              class="mr-3 mb-2"
              v-model="FBM.data.PhotoPrint.data.isPhotoPrint"
              :label="$t('calculatorEngraving_PhotoPrint.localization_value.value')"
              @changeCheckbox="(val) => changeCustomizationType('isPhotoPrint', val)"
          />
          <DefaultCheckbox
              v-if="!isWarehouseLodz && !isWarehouseCambridge"
              v-model="FBM.data.UVPrinting.data.isUVPrinting"
              :label="$t('calculatorEngraving_UVPrinting.localization_value.value')"
              @changeCheckbox="(val) => changeCustomizationType('isUVPrinting', val)"
          />
        </div>

      </div>

      <div class="order-create__section-label section-label" v-if="FBM.data.isEngraving">
        {{$t('fbm_EngravingFileName.localization_value.value')}}
      </div>
      <Engraving
          v-if="FBM.data.isEngraving"
          :FBM="FBM"
          :engravingCustomOptions="engravingCustomOptions"
          @changeCustomization="changeCustomization"
          @changeQuantity="changeQuantity"
      />

      <div class="order-create__section-label section-label" v-if="FBM.data.Embroidery.data.isEmbroidery">
        {{$t('calculatorEngraving_EmbroideryCalculator.localization_value.value')}}
      </div>
      <Embroidery
          v-if="FBM.data.Embroidery.data.isEmbroidery"
          :embroideryCustomOptions="embroideryCustomOptions"
          :FBM="FBM"
          @changeCustomization="changeCustomization"
      />

      <div class="order-create__section-label section-label" v-if="FBM.data.TShirtPrinting.data.isTShirtPrinting">
        {{$t('calculatorEngraving_TShirtPrinting.localization_value.value')}}
      </div>
      <TShirtPrinting
          v-if="FBM.data.TShirtPrinting.data.isTShirtPrinting"
          :FBM="FBM"
          :dtgPrintingCustomOptions="dtgPrintingCustomOptions"
          @changeCustomization="changeCustomization"
          @changeQuantity="changeQuantity"
      />

      <div class="order-create__section-label section-label" v-if="FBM.data.LeatherStamp.data.isLeatherStamp">
        {{$t('calculatorEngraving_LeatherStamp.localization_value.value')}}
      </div>
      <LeatherStamp
          v-if="FBM.data.LeatherStamp.data.isLeatherStamp"
          :FBM="FBM"
          :leatherStampCustomOptions="leatherStampCustomOptions"
          @changeCustomization="changeCustomization"
          @changeQuantity="changeQuantity"
      />

      <div class="order-create__section-label section-label" v-if="FBM.data.PhotoPrint.data.isPhotoPrint">
        {{$t('calculatorEngraving_PhotoPrint.localization_value.value')}}
      </div>
      <PhotoPrint
          v-if="FBM.data.PhotoPrint.data.isPhotoPrint"
          :FBM="FBM"
          :photoPrintSizeOptions="photoPrintSizeOptions"
          :photoPrintCustomOptions="photoPrintCustomOptions"
          @changeCustomization="changeCustomization"
          @changeQuantity="changeQuantity"
      />

      <div class="order-create__section-label section-label" v-if="FBM.data.UVPrinting.data.isUVPrinting">
        {{$t('calculatorEngraving_UVPrinting.localization_value.value')}}
      </div>
      <UVPrinting
          v-if="FBM.data.UVPrinting.data.isUVPrinting && !isWarehouseLodz && !isWarehouseCambridge"
          :FBM="FBM"
          :UVPrintingCustomOptions="UVPrintingCustomOptions"
          @changeCustomization="changeCustomization"
          @changeQuantity="changeQuantity"
      />

    </div>
  </div>
</template>

<script>
import DefaultCheckbox from "@/components/UI/checkboxes/DefaultCheckbox/DefaultCheckbox";
import Engraving
  from "@/components/modules/OrdersFBMModule/components/components/chunks/EngravingFile/components/Engraving";
import Embroidery
  from "@/components/modules/OrdersFBMModule/components/components/chunks/EngravingFile/components/Embroidery";
import TShirtPrinting
  from "@/components/modules/OrdersFBMModule/components/components/chunks/EngravingFile/components/TShirtPrinting";
import {productForCellMixin} from "@/mixins/productMixins/productForCellMixin";
import LeatherStamp
  from "@/components/modules/OrdersFBMModule/components/components/chunks/EngravingFile/components/LeatherStamp";
import PhotoPrint
  from "@/components/modules/OrdersFBMModule/components/components/chunks/EngravingFile/components/PhotoPrint";
import {FBMMixinsHelper} from "@/mixins/FBMMixins/FBMMixins";
import UVPrinting
  from "@/components/modules/OrdersFBMModule/components/components/chunks/EngravingFile/components/UVPrinting";

export default {
name: "EngravingFile",
  components: {UVPrinting, PhotoPrint, LeatherStamp, TShirtPrinting, Embroidery, Engraving, DefaultCheckbox,},

  props: {
    FBM: Object,
  },

  mixins: [productForCellMixin, FBMMixinsHelper],

  data() {
    return {
      engravingCustomOptions: [],
      embroideryCustomOptions: [],
      dtgPrintingCustomOptions: [],
      leatherStampCustomOptions: [],
      photoPrintSizeOptions: [],
      photoPrintCustomOptions: [],
      UVPrintingCustomOptions: [],
    }
  },

  mounted() {
    this.$store.dispatch('getTShirtCalcCreate').then(response => {


      let data = this.getRespData(response)?.customization_offers

      this.engravingCustomOptions = data?.engraving
      this.embroideryCustomOptions = data?.embroidery
      this.dtgPrintingCustomOptions = data?.dtg_printing
      this.UVPrintingCustomOptions = data?.uv_printing

      this.leatherStampCustomOptions = data?.leather_stamping
      this.photoPrintSizeOptions = data?.photo_printing_size
      this.photoPrintCustomOptions = data?.photo_printing

      // Object.keys(this.getRespData(response)?.colorType).map((item) => {
      //   this.colorOptions.push({
      //     value: item,
      //     translation: this.getRespData(response)?.colorType[item],
      //   })
      //   // if(index === 0) this.TShirtPrinting.data.color = this.colorOptions[0].value
      // })
      //
      // Object.keys(this.getRespData(response)?.type).map((item) => {
      //   this.qualityOptions.push({
      //     value: item,
      //     translation: this.getRespData(response)?.type[item],
      //   })
      //   // if(index === 0) this.TShirtPrinting.data.quality = this.qualities[0].value
      // })

    })
  },

  methods: {

    changeQuantity(item, quantity) {
      let productId = item?.product_id
      let productsCellArray = this.FBM.data.productsForCellArray

      if(productId) {
        productsCellArray.map((item) => {
          if(item.data.Product?.product?.id === productId) {
            item.data.Product.setProductCount(Number(quantity) || 0)
          }
        })
      }
    },

    async changeCustomization(oldItem, newItem, quantity = 1) {
      console.log(oldItem, newItem, quantity);
      let oldProductId = oldItem?.product_id
      let newProductId = newItem?.product_id
      let productsCellArray = this.FBM.data.productsForCellArray

      if(oldProductId) {
        let foundIndex = null
        productsCellArray.map((item, index) => {
          if(item.data.Product?.product?.id === oldProductId) {
            foundIndex = index
          }
        })
        if(foundIndex !== null) {
          productsCellArray.splice(foundIndex, 1)
        }
      }

      if(newProductId) {
        await this.$store.dispatch('fetchSpecialProducts', `?filter[ProductId]=${newProductId}&page=0&limit=100000`).then(response => {
          let product = this._.first(this.getRespPaginateData(response))
          if(product) {
            let index = null
            if(productsCellArray.length === 1 && productsCellArray[0].data.Product.getProductId() === '') {
              index = 0
            } else {
              index = this.FBM.addProductForCells()
            }

            productsCellArray[index].data.Product.setProduct(product)
            productsCellArray[index].data.Product.setProductCount(quantity)
            productsCellArray[index].data.Product.setProductPrice(1)
            productsCellArray[index].data.Product.setProductDescription('system product')

            if(this.isAdmin) {
              let userId = productsCellArray[index].data.Product.product?.productObject?.user_id
              this.getCellsForUser(productsCellArray[index], userId, this.FBM.data?.Order.data.warehouse?.id)
              productsCellArray[index].data.productCount = 1
            }
          }
        })
      }

      if(productsCellArray.length === 0) {
        this.FBM.addProductForCells()
      }

    },

    changeCustomizationType(type, val) {

      switch (type) {
        case 'isEngraving' :
          // this.FBM.data.TShirtPrinting.data.isTShirtPrinting = false
          // this.FBM.data.Embroidery.data.isEmbroidery = false
          // this.FBM.data.LeatherStamp.data.isLeatherStamp = false
          // this.FBM.data.PhotoPrint.data.isPhotoPrint = false
          this.FBM.data.isEngraving = val
          this.changeCustomization(this.FBM.data.engravingCustomization,
              this.FBM.data.isEngraving ? this.FBM.data.engravingCustomization : null)
          break
        case 'isTShirtPrinting' :
          // this.FBM.data.isEngraving = false
          // this.FBM.data.Embroidery.data.isEmbroidery = false
          // this.FBM.data.LeatherStamp.data.isLeatherStamp = false
          // this.FBM.data.PhotoPrint.data.isPhotoPrint = false
          this.FBM.data.TShirtPrinting.data.isTShirtPrinting = val
          this.changeCustomization(this.FBM.data.TShirtPrinting.data.customization,
              this.FBM.data.TShirtPrinting.data.isTShirtPrinting ? this.FBM.data.TShirtPrinting.data.customization : null)
          break
        case 'isEmbroidery' :
          // this.FBM.data.isEngraving = false
          // this.FBM.data.TShirtPrinting.data.isTShirtPrinting = false
          // this.FBM.data.LeatherStamp.data.isLeatherStamp = false
          // this.FBM.data.PhotoPrint.data.isPhotoPrint = false
          this.FBM.data.Embroidery.data.isEmbroidery = val
          this.changeCustomization(this.FBM.data.Embroidery.data.customization,
              this.FBM.data.Embroidery.data.isEmbroidery ? this.FBM.data.Embroidery.data.customization : null)
          break
        case 'isLeatherStamp' :
          // this.FBM.data.isEngraving = false
          // this.FBM.data.TShirtPrinting.data.isTShirtPrinting = false
          // this.FBM.data.Embroidery.data.isEmbroidery = false
          // this.FBM.data.PhotoPrint.data.isPhotoPrint = false
          this.FBM.data.LeatherStamp.data.isLeatherStamp = val
          this.changeCustomization(this.FBM.data.LeatherStamp.data.customization,
              this.FBM.data.LeatherStamp.data.isLeatherStamp ? this.FBM.data.LeatherStamp.data.customization : null)
          break
        case 'isPhotoPrint' :
          // this.FBM.data.isEngraving = false
          // this.FBM.data.TShirtPrinting.data.isTShirtPrinting = false
          // this.FBM.data.Embroidery.data.isEmbroidery = false
          // this.FBM.data.LeatherStamp.data.isLeatherStamp = false
          this.FBM.data.PhotoPrint.data.isPhotoPrint = val
          this.changeCustomization(this.FBM.data.PhotoPrint.data.customization,
              this.FBM.data.PhotoPrint.data.isPhotoPrint ? this.FBM.data.PhotoPrint.data.customization : null)
          break
        case 'isUVPrinting' :
          this.FBM.data.UVPrinting.data.isUVPrinting = val
          this.changeCustomization(this.FBM.data.UVPrinting.data.customization,
              this.FBM.data.UVPrinting.data.isUVPrinting ? this.FBM.data.UVPrinting.data.customization : null)
          break
      }

      // this.resetNotCheckedCustomizationProduct()
    },

    resetNotCheckedCustomizationProduct() {

      this.changeCustomization(this.FBM.data.TShirtPrinting.data.customization,
          this.FBM.data.TShirtPrinting.data.isTShirtPrinting ? this.FBM.data.TShirtPrinting.data.customization : null)

      this.changeCustomization(this.FBM.data.Embroidery.data.customization,
          this.FBM.data.Embroidery.data.isEmbroidery ? this.FBM.data.Embroidery.data.customization : null)

      this.changeCustomization(this.FBM.data.engravingCustomization,
          this.FBM.data.isEngraving ? this.FBM.data.engravingCustomization : null)

      this.changeCustomization(this.FBM.data.LeatherStamp.data.customization,
          this.FBM.data.LeatherStamp.data.isLeatherStamp ? this.FBM.data.LeatherStamp.data.customization : null)

      this.changeCustomization(this.FBM.data.PhotoPrint.data.customization,
          this.FBM.data.PhotoPrint.data.isPhotoPrint ? this.FBM.data.PhotoPrint.data.customization : null)
    },


  }
}
</script>

<style scoped>

</style>